import { useEffect, useState } from "react";

export const HorizontalLevels = ({ level, maxLevel }) => {
    const [width, setWidth] = useState("0%");

    useEffect(() => {
        // Trigger animation after component mounts
        const timer = setTimeout(() => {
            const targetWidth = `${((level + 1) / maxLevel) * 100}%`;
            setWidth(targetWidth);
        }, 0);

        return () => clearTimeout(timer);
    }, [level, maxLevel]);

    return (
        <div className="relative w-full h-2 rounded-[29px] bg-cm-p-surface-container">
            <div
                className="absolute top-0 left-0 h-2 rounded-[29px] bg-cm-p-accent-500 transition-[width] ease-in-out"
                style={{
                    width,
                    transitionDuration: "2000ms",
                }}
            />
        </div>
    );
};
